"use client"
import ContentMarkdown from "@/components/modules/ContentOne/ContentMarkdown"
import clsx from "clsx"
import React from "react"

const ContentFeature: React.FunctionComponent<{
    locale: string,
    variant?: "h1" | "h2" | "h3" | "h4",
    block?: any, className?: string,
    handleChangePicture?: any
}> = ({
    locale,
    variant = "h2",
    block,
    handleChangePicture
}) => {

        const [show, setShow] = React.useState<number | undefined>()

        const handleToggle = (event: any, id: number, index: number) => {
            if (show && show === id) return setShow(undefined);
            setShow((prev?: number | undefined) => id)
            return handleChangePicture(index)
        }
        return (
            <>
                <div className="content__one__header mb-md-3">
                    {block.subtitle && (<p className="subtitle fw-semi-bold">{block.subtitle}</p>)}
                    {block.title && React.createElement(variant, {}, block.title)}
                    {block.description && <p>{block.description}</p>}
                </div>
                {block.content && block.content !== "" && (
                    <div className="content__one__content">
                        <ContentMarkdown locale={locale} content={block.content} />
                    </div>
                )}
                {block.blocks && block.blocks.length !== 0 && (
                    <div className="content__one__blocks">
                        {block.blocks.map((item: any, index: number) => {
                            return (
                                <div className={clsx("content__one__block", show === item.id ? "show" : "")} key={index} onClick={(event) => handleToggle(event, item.id, index)}>
                                    <div className="d-flex text-start justify-content-between">
                                        {item.title && <p className="fw-semi-bold">{item.title}</p>}
                                        <i className={clsx("img", "arrow-down-small")} />
                                    </div>
                                    <div className="description">
                                        <ContentMarkdown locale={locale} content={item.content} />
                                    </div>
                                </div>
                            )
                        })}
                    </div>
                )}
            </>
        )
    }

export default ContentFeature
